import { render } from "./totalDisplayComp.vue?vue&type=template&id=2355fe09&scoped=true"
import script from "./totalDisplayComp.vue?vue&type=script&lang=js"
export * from "./totalDisplayComp.vue?vue&type=script&lang=js"

import "./totalDisplayComp.vue?vue&type=style&index=0&id=2355fe09&scoped=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2355fe09"]])

export default __exports__